module.exports = __webpack_public_path__ + "img/logo-rsca.3fc9b7ad.png";